/*
 * @Author: dongbo 254126189@qq.com
 * @Date: 2023-12-27 09:21:09
 * @LastEditors: dongbo 254126189@qq.com
 * @LastEditTime: 2024-01-26 16:28:02
 * @FilePath: /hippo-app-h5/hippo-app-h5/src/router/modules/protocol.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/help/protocol',
    name: 'protocol',
    meta: {
      title: '',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/help/protocol/index.vue'),
  },
  {
    path: '/help/protocolForAndroid',
    // 解决聚合app安卓设备 a标签跳转bug
    // 本链接，管理后台专用
    // bug描述：
    // 从 https://hippo-app-test.gwmapp-h.com/sapp-h5/index.html#/help/protocol?type=2 跳转到 https://hippo-app-test.gwmapp-h.com/sapp-h5/index.html#/help/protocol?type=1
    // 失效
    name: 'protocolForAndroid',
    meta: {
      title: '',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/help/protocol/protocolForAndroid.vue'),
  },
  {
    path: '/help/enclosure',
    name: 'enclosure',
    meta: {
      title: '附件',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/help/enclosure/index.vue'),
  },
]

export default routes
